module.exports = __webpack_public_path__ + "static/media/twitter-dark.459bf64b.svg";